import Image from "next/image";
import { FunctionComponent, memo } from "react";

import styles from "./ThemeHeader.module.scss";

import ProgressBar from "@components/generic/progressBar";
import { ThemeCode, selectThemeImage } from "@lib/helper/themeUtils";

export interface IThemeHeaderProps {
  name: string;
  score: number;
  themeCode: ThemeCode;
}

const ThemeHeader: FunctionComponent<IThemeHeaderProps> = ({ name, score, themeCode }) => {
  const imageTheme = selectThemeImage(themeCode);

  return (
    <div className={`${styles["theme-header"]}`}>
      <div className={styles["theme-header__detailled"]}>
        <div className={styles["theme-header__theme-icon"]}>
          <Image
            src={imageTheme}
            alt={`${name} icon`}
            width={24}
            height={24}
            priority={true}
            sizes="10vw"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </div>
        <h3 className={styles["theme-header__title"]}>{name}</h3>
      </div>
      <ProgressBar value={score} isScore />
    </div>
  );
};

export default memo(ThemeHeader);
